import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { AmountHelper } from "../../../../helpers/AmountHelper";
import { VatTypeEnum } from "../../../../enums/VatTypeEnum";
import { useTranslation } from "react-i18next";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";
import { NFPlainNumber } from "../../../Shared/NewForms/NFPlainNumber";
import { NFLookupIncomeItem } from "../../../Shared/NewForms/NFLookupIncomeItem";
import { NFLookupUnit } from "../../../Shared/NewForms/NFLookupUnit";
import { NFLookupBaseDocuments } from "../../../Shared/NewForms/NFLookupBaseDocuments";

export const ProductionAndSalesDetailProducts = () => {
    const tableName = "products";
    const { setValue, getValues } = useFormContext();
    const { t } = useTranslation();

    const handleQuantityChanged = (newQuantity: number, index: number) => {
        const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
            newQuantity,
            getValues(`${tableName}.${index}.price`),
            getValues(`${tableName}.${index}.vatType`),
            getValues("priceIncludesVat")
        );
        setValue(`${tableName}.${index}.amount`, newAmounts.amount);
        setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
        setValue(
            `${tableName}.${index}.amountWithVat`,
            newAmounts.amountWithVat
        );
    };

    const handlePriceChanged = (newPrice: number, index: number) => {
        const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
            getValues(`${tableName}.${index}.quantity`),
            newPrice,
            getValues(`${tableName}.${index}.vatType`),
            getValues("priceIncludesVat")
        );
        setValue(`${tableName}.${index}.amount`, newAmounts.amount);
        setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
        setValue(
            `${tableName}.${index}.amountWithVat`,
            newAmounts.amountWithVat
        );
    };

    useEffect(() => {}, []);

    return (
        <>
            <NFormTable fieldArray={"products"}>
                <NFLookupBaseDocuments
                    fieldName={"parentDocumentId"}
                    title={"Base Document at ID"}
                />
                <NFLookupBaseDocuments
                    fieldName={"specificationId"}
                    title={"Specificatic"}
                />
                <NFLookupUnit fieldName={"unitId"} title={"Unit"} width={200} />
                <NFIntInput
                    fieldName={"quantity"}
                    title={"Quantity"}
                    onValueChanged={handleQuantityChanged}
                    width={100}
                />
                <NFIntInput
                    fieldName={"price"}
                    title={"Price"}
                    onValueChanged={handlePriceChanged}
                    width={100}
                />
                <NFIntInput fieldName={"amount"} title={"Amount"} width={100} />
                <NFIntInput
                    fieldName={"priceWithDiscount"}
                    title={"Price With Sale"}
                    width={100}
                />
                <NFIntInput fieldName={"amount"} title={"Amount"} width={100} />
                <NFIntInput
                    fieldName={"vatAmount"}
                    title={"vatAmount"}
                    width={100}
                />
                <NFIntInput
                    fieldName={"vatAmount"}
                    title={"Amount With VAT"}
                    width={100}
                />
                {/*  */}
            </NFormTable>
        </>
    );
};
